import * as angular from 'angular';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';
import { Types } from '../models/configuration.model';
export class SubscriptionModelsUtilService {
    public numberAttemps: number = 0;
    constructor (
        private $window: ng.IWindowService,
        private CommonsGenericProxy: CommonsGenericProxy,
        private $cookies: angular.cookies.ICookiesService, private CommonsModalService:CommonsModalService,
        private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant, private tmhDynamicLocale: any, private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private $timeout: ng.ITimeoutService,
        private NewMainHeaderFacade: any,
        private DatalayerUtilsService: DatalayerUtilsService,
        private $filter: angular.IFilterService) {

    }

    ////////////////
    /**
     * Returns the type of the device depending on the channel and the width of the screen.
     * @returns {Object.<Promise>} - returns a string. desktop|tablet|mobile
     */
    getDeviceType = (): string => {
        let deviceType: string = '';
        const channel: string = this.CommonsSessionStorageService.get('channel');
        if (channel === 'mobi') {
            deviceType = 'mobile';
        } else {
            const width = this.$window.innerWidth;
            if (width) {
                if (width > 1024) {
                    deviceType = 'desktop';
                } else if (width > 480 && width < 1025) {
                    deviceType = 'tablet';
                } else if (width < 481) {
                    deviceType = 'mobile';
                }
            }
        }
        return deviceType;
    };

    setTitlePage = (): void => {
        setTimeout(() => {
            this.$window.document.title = this.$filter('translate')('SUBSCRIPTION_MODELS_CONFIGURATION_SUBSCRIPTION_MODELS_TEXT');
        }, 1000);
    };

    /**
     * Return date in string
     * @param {Object} date Date
     */
    getTransformedDate = (date: Date): string => {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    };


    /**
     * Remove all localstorage variables of the app
     */
    initStorage = (): void => {
        this.CommonsSessionStorageService.remove('loggedToken');
        this.CommonsSessionStorageService.remove('refreshToken');
        this.CommonsSessionStorageService.remove('customerData');
        this.CommonsSessionStorageService.remove('userLogged');
        this.CommonsSessionStorageService.remove('customerCreditCardsData');
    };
    convertDateToUTC =(date:any):Date => {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    };

    tokenExpired = (tokenExpiration:string):boolean => {
        let ok = true;
        let tokenSplit = [];
        if (tokenExpiration) {
            tokenSplit = tokenExpiration.split('/');
            tokenExpiration = tokenSplit[1] + '/' + tokenSplit[0] + '/' + tokenSplit[2];
            const tokenDate = Date.parse(tokenExpiration);
            ok = tokenDate <= this.convertDateToUTC(new Date()).getTime();
        }
        return ok;
    };

    getLoggedCookiesInfo = () => {
        const cookieAccessToken = this.$cookies.get('IBERIACOM_SSO_ACCESS');
        const cookieAccessTokenExpire = this.$cookies.get('IBERIACOM_SSO_ACCESS_TO');
        const cookieSSOINFO = this.$cookies.get('IBERIACOM_SSO_INFO');
        const cookieRefreshToken = this.$cookies.get('IBERIACOM_SSO_REFRESH');
        const cookieRefreshTokenExpire = this.$cookies.get('IBERIACOM_SSO_REFRESH_TO');

        let userLogged = false;
        if (angular.isDefined(cookieRefreshToken) && !this.tokenExpired(cookieRefreshTokenExpire)) {
            userLogged = true;
            this.CommonsSessionStorageService.set('userLogged', true);
            this.CommonsSessionStorageService.set('loggedToken', cookieAccessToken);
            this.CommonsSessionStorageService.set('refreshToken', cookieRefreshToken);
            this.getCustomerData();

        }else {
            this.$timeout(() => {
                this.initHeader();
            }, 1000);
        }
        return {
            userLogged: userLogged,
            cookieAccessToken: cookieAccessToken,
            cookieAccessTokenExpire: cookieAccessTokenExpire,
            cookieRefreshToken: cookieRefreshToken,
            cookieRefreshTokenExpire: cookieRefreshTokenExpire,
            cookieSSOINFO: cookieSSOINFO
        };
    };
    setQuadrigamInfo = ():string => {
        let cardDestiny:string;
        const localInfo:string = this.CommonsSessionStorageService.get('giftCardDestiny');
        cardDestiny = this.SubscriptionModelsAppConstants.QUADRIGAMS.PLAPAX;
        return cardDestiny;
    };
    /**
         * check if the current user is logged or not
         * @return true if the user is logged in the app
         */
    isUserLogged = (): boolean => {
        if (!this.CommonsSessionStorageService.get('userLogged')) {
            this.$cookies.remove('userLogged');
        } else {
            this.$cookies.put('userLogged', 'true');
        }
        return this.CommonsSessionStorageService.get('userLogged');
    };
    updateMarketLang = (marketLang) => {
        const lang = marketLang.language;
        const market = marketLang.market;
        const content = market + '|' + market + '|' + lang + '| | |' + market + '|';
        const expiration = new Date();
        expiration.setTime(expiration.getTime() + this.SubscriptionModelsAppConstants.COOKIES.DEFAULT_EXPIRY_TIME);
        this.$cookies.put(this.SubscriptionModelsAppConstants.COOKIES.PERSONALIZATION, content, { expires: expiration, path: this.SubscriptionModelsAppConstants.COOKIES.DEFAULT_PATH });
        this.SubscriptionModelsAppConstants.market = market;
        this.SubscriptionModelsAppConstants.lang = lang;
        this.tmhDynamicLocale.set(lang);
    };
    getStep = (): string => {
        let step = '';

        if(this.getQuadrigam() === this.SubscriptionModelsAppConstants.QUADRIGAMS.PLAPAX) {
            step = this.SubscriptionModelsAppConstants.QUADRIGAMS.STEPS.CONFIGURACION;
        }else if(this.getQuadrigam() === this.SubscriptionModelsAppConstants.QUADRIGAMS.GIFTCARDS_PAYMENT) {
            step = this.SubscriptionModelsAppConstants.QUADRIGAMS.STEPS.PAGO;
        }else {
            step = this.SubscriptionModelsAppConstants.QUADRIGAMS.STEPS.CONFIRMACION;
        }

        return step;
    };
    getQuadrigam = ():string => {
        let quadrigam:string;
        const redirectionPaymentCallback = this.CommonsSessionStorageService.get('redirectionPaymentCallback');

        const url = this.$window.location.href.split('/');
        const page = url[url.length-1];
        if(redirectionPaymentCallback && page === this.SubscriptionModelsAppConstants.STEPS.PAGOS) {
            const datalayer_back = this.CommonsSessionStorageService.get('datalayer_general_Back');
            if(datalayer_back) {
                this.DatalayerUtilsService.updateDatalayerWithQuadrigam(null, datalayer_back, this.isUserLogged());
            }
            quadrigam = this.SubscriptionModelsAppConstants.QUADRIGAMS.GIFTCARDS_PAYMENT;
        }else{
            quadrigam = this.SubscriptionModelsAppConstants.QUADRIGAMS.PLAPAX;
        }
        return quadrigam;
    };
    getCustomerData = (): angular.IPromise<any | Types.ErrorResponse> => {
        const endpoint = this.SubscriptionModelsAppConstants.DEFAULT_ENDPOINTS.customerDataURI;
        return new Promise( (resolve, reject) => {
            this.CommonsGenericProxy.getGeneric(`${endpoint}`).then((response) => {
                this.CommonsModalService.finishWaiting();
                this.CommonsSessionStorageService.set('customerData', response.data);
                this.initHeader();
                resolve(response);
            }, (error) => {
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
            });
        });
    };
    initHeader = () => {
        this.NewMainHeaderFacade.initHeader(
            {
                originDestination: null,
                redemption: '',
                flightType: null,
                currency: '',
                showBasket: false
            },
            { hasSteps: true, steps: this.SubscriptionModelsAppConstants.STEPS.STEPS, position: this.SubscriptionModelsAppConstants.STEPS.HOME },
            {
                onLogin: (): void => { },
                onError: (): void => { },
                afterLogin: () => { },
                userLogged: this.CommonsSessionStorageService.get('userLogged'),
                isLogged: this.CommonsSessionStorageService.get('userLogged'),
                loggedData: this.CommonsSessionStorageService.get('customerData') || this.CommonsSessionStorageService.get('membershipData') || undefined,
                show: true
            }
        );
    };

    /**
     * Returns the market from url
     * @returns {string} - returns an string made from params
     */
    getParameterByName = (name: string, url?: string): string => {
        if (!url) url = this.$window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi' );
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return null;
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    /**
     * Redirection to Home
     * @param event
     * @param {Boolean} goToHome  Indicate if the redirection is for Home
     * @param {Boolean} closeSession indicate if neccesary delete the session
     * @returns {void}
     */
    backToMain = (goToHome: boolean, closeSession?: boolean) => {
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true, null);
        if (goToHome) {
            this.$window.location.href = this.$window.location.origin;
        }
    };

    /**
     * Return the background image in the project.
     * @returns {String} - the background image url that matches with its destination city code in the data on localStorage
     */
    getBackGroundURL= () => {
        const innerWidth = this.$window.innerWidth;
        let widthScreen: number;
        if (innerWidth > 0 && innerWidth <= 480) {
            widthScreen = 320;
        } else if (innerWidth <= 1024) {
            widthScreen = 768;
        } else {
            widthScreen = 2000;
        }
        return `${this.SubscriptionModelsAppConstants.backgroundImagesBaseRoute}${this.SubscriptionModelsAppConstants.defaultBackgroundImageWidth}${widthScreen}.jpg`;
    };
}
SubscriptionModelsUtilService.$inject = [
    '$window',
    'CommonsGenericProxy',
    '$cookies',
    'CommonsModalService',
    'SubscriptionModelsAppConstants',
    'tmhDynamicLocale',
    'CommonsNewHttpUtilsErrorService',
    'CommonsSessionStorageService',
    '$timeout',
    'NewMainHeaderFacade',
    'DatalayerUtilsService',
    '$filter'
];
try {
    const mod = angular.module('ib-subscription-models-service-module');
    mod.service(
        'SubscriptionModelsUtilService',
        SubscriptionModelsUtilService
    );
} catch (error) {
    const mod = angular.module('ib-subscription-models-service-module', []);
    mod.service(
        'SubscriptionModelsUtilService',
        SubscriptionModelsUtilService
    );
}
